import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import QnaHeader from '../../components/Qna/Qna/QnaHeader';
import QnaSide from '../../components/Qna/Qna/QnaSide';
import QnaList from '../../components/Qna/Qna/QnaList';

const Qna = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(() => {
    return location.state?.categoryId ?? null;
  });
  const topRef = useRef(null);
  const isCategoryChangeRef = useRef(false);
  const [filterState, setFilterState] = useState({
    sortBy: 'Newest',
    onlyAnswered: false,
    onlyUnanswered: false,
  });

  useEffect(() => {
    const categoryId = location.state?.categoryId;
    if (categoryId != null) {
      setActiveCategory(categoryId);
      isCategoryChangeRef.current = true;
    }
  }, [location.pathname, location.state, navigate]);

  return (
    <div className='bg-grayscale-gray01 min-h-screen pb-[100px] tabletH:px-6 tabletH:pt-[100px] tabletH:pb-[180px]'>
      <QnaHeader
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        filterState={filterState}
        setFilterState={setFilterState}
        isCategoryChangeRef={isCategoryChangeRef}
      />
      <div ref={topRef} className='flex items-center justify-center px-4'>
        <div className='grid grid-cols-1 tabletH:grid-cols-[270px_minmax(0,1fr)] gap-6 items-start'>
          <div className='hidden sm:block self-stretch'>
            <QnaSide
              activeCategory={activeCategory}
              setActiveCategory={setActiveCategory}
              filterState={filterState}
              setFilterState={setFilterState}
            />
          </div>
          <div className='w-full min-w-0'>
            <QnaList
              activeCategory={activeCategory}
              topRef={topRef}
              filterState={filterState}
              isCategoryChangeRef={isCategoryChangeRef}
              useIn='QnA'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Qna;
